let charactersData = [
    {
        "name": "Executive",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Biker",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Royalty",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "VIP",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Occultist",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Cowboy",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Foreigner",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Patriot",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Rockstar",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Druggie",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Pirate",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Rich Person",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Spot Monkey",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Big Shot",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Drug Lord",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Philosophist",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Abstainer",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Bully",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Sidekick",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Brute",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Lunatic",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Underdog",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Opportunist",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Degenerate",
        "level": 2,
        "tag": "behavior",
        "standard": false
    },
    {
        "name": "Prize Fighter",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Punk",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Enigma",
        "level": 2,
        "tag": "behavior",
        "standard": false
    },
    {
        "name": "Jock",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Child",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Body-builder",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Cheerleader",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Police Officer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Shoot Fighter",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Movie Star",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Amateur Wrestler",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Sports Star",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Rapper",
        "level": 2,
        "tag": "career",
        "standard": false
    },
    {
        "name": "Singer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Musician",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Game Dev.",
        "level": 2,
        "tag": "career",
        "standard": false
    },
    {
        "name": "Kickboxer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Undead",
        "level": 2,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Monster",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Cult Leader",
        "level": 2,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Voodoo",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Martian",
        "level": 3,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Demon",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Vampire",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Superhero",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Fighter",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Wrestler",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Superstar",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Rising Star",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Thug",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Mythical Being",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Giant",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Veteran",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Mobster",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    }
];

export {charactersData}